import { useTranslation } from 'react-i18next'
import { OnboardingGetStartedIcon } from '../../../icons/OnboardingGetStartedIcon'

export function GetStartedSlide() {
  const { t } = useTranslation()

  return (
    <div className="onboarding-page__slide">
      <OnboardingGetStartedIcon />
      <div className="onboarding-page__text-container">
        <h1 className="onboarding-page__title">
          {t('onboarding.getStarted.title')}
        </h1>
        <p className="onboarding-page__description">
          {t('onboarding.getStarted.description')}
        </p>
      </div>
    </div>
  )
}
